import React from "react";
import { Clock, Activity } from "lucide-react";
import Card from "../../../shared/components/Card";

const RecentActivities = ({ activities }) => {
  return (
    <div className="lg:col-span-2">
      <Card>
        <h2 className="text-lg font-semibold mb-4 flex items-center">
          <Clock size={20} className="mr-2" />
          Recent Activities
        </h2>

        <div className="space-y-4">
          {activities?.length ? (
            activities.map((activity) => (
              <div key={activity.id} className="flex justify-between py-2 border-b">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                    <Activity size={16} />
                  </div>

                  <div className="ml-3">
                    <p className="text-sm font-medium">{activity.user}</p>
                    <p className="text-xs text-gray-500">
                      {activity.action} - {activity.model}
                    </p>
                  </div>
                </div>

                <span className="text-xs text-gray-500">
                  {new Date(activity.created_at).toLocaleString()}
                </span>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center py-4">
              No recent activities
            </p>
          )}
        </div>
      </Card>
    </div>
  );
};

export default React.memo(RecentActivities);